const parseTeam = (team) => team || '';

export const getTeamsById = (resp = []) => {
  const allTeams = [];

  (Array.isArray(resp) ? resp : []).forEach((entry) => {
    const teams = entry?.teams;
    if (teams) {
      allTeams.push(teams);
    }
  });

  return allTeams.reduce((acc, curr) => {
    const homeTeam = curr?.home;
    const awayTeam = curr?.away;
    if (!homeTeam?.id || !awayTeam?.id) {
      return acc;
    }

    return {
      ...acc,
      [homeTeam.id]: {
        ...homeTeam,
        abbr: parseTeam(homeTeam.abbr),
        city: parseTeam(homeTeam.city),
        id: parseTeam(homeTeam.id),
        logo: parseTeam(homeTeam.logo),
        name: parseTeam(homeTeam.name),
      },
      [awayTeam.id]: {
        ...awayTeam,
        abbr: parseTeam(awayTeam.abbr),
        city: parseTeam(awayTeam.city),
        id: parseTeam(awayTeam.id),
        logo: parseTeam(awayTeam.logo),
        name: parseTeam(awayTeam.name),
      },
    };
  }, {});
};
